/** Formateadores de fecha específicos de Flujo Semanal (traídos de adelante-flujosemanal). */
const fmtFechaCorta = new Intl.DateTimeFormat('es-CR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'America/Costa_Rica',
});
export function formatearFecha(iso) {
    const [anio, mes, dia] = iso.split('-').map(Number);
    if (!anio || !mes || !dia)
        return iso;
    const fecha = new Date(anio, mes - 1, dia);
    return fmtFechaCorta.format(fecha);
}
export function formatearRangoSemana(inicio, fin) {
    return `${formatearFecha(inicio)} – ${formatearFecha(fin)}`;
}
const fmtMesAnio = new Intl.DateTimeFormat('es-CR', { month: 'long', year: 'numeric' });
/** Etiqueta "Octubre 2026" a partir de año y mes (1-12), con la inicial en mayúscula. */
export function formatearMesAnio(anio, mes) {
    const texto = fmtMesAnio.format(new Date(anio, mes - 1, 1));
    return texto.charAt(0).toUpperCase() + texto.slice(1);
}
//# sourceMappingURL=formatearFechaFlujo.js.map